/**
 * @constant {Object}
 */
export const initialState = {
    init: false,
    isLoading: true,
};

/**
 * @constant {Object}
 */
export const loadedState = {
    isLoading: false,
};

/**
 * @constant {Object}
 */
export const loadingState = {
    isLoading: true,
};

/**
 * @constant {Object}
 */
export const emptyState = {
    isLoading: false,
    scheduleIsEmpty: true,
};
